export const buttonText = "create";
export const forgetPasswordMessage =
  "The reset password link is shared on your registered email id. Please click on the link to proceed further.";
